let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kgx4U")).then(() => parcelRequire('iAkpb'));